import { render, staticRenderFns } from "./InputRange.vue?vue&type=template&id=084c0b36&"
import script from "./InputRange.vue?vue&type=script&lang=js&"
export * from "./InputRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports